import { useMemo } from 'react';
import { getRootConfig } from './config';
import { RootConfigSchema } from './interfaces';

export const useRootConfig = (): RootConfigSchema => {
  const rootConfigMemoized = useMemo(() => getRootConfig(), []);

  return rootConfigMemoized;
};
